import { createContext, useContext, useState, useCallback } from "react";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const [currentRelease, setCurrentRelease] = useState(null);
  const [currentTrack, setCurrentTrack] = useState(null); // {uri, title, trackId}
  const [playToken, setPlayToken] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  // Load a release (or a specific track within it) into the persistent player.
  const playRelease = useCallback((release, trackOverride = null) => {
    const uri =
      trackOverride?.spotifyURI ||
      release?.spotifyURI ||
      (release?.spotifyTrackId ? `spotify:track:${release.spotifyTrackId}` : null) ||
      (release?.spotifyAlbumId ? `spotify:album:${release.spotifyAlbumId}` : null);
    if (!uri) return;
    setCurrentRelease(release);
    setCurrentTrack({
      uri,
      title: trackOverride?.title || release?.title,
      trackId: trackOverride?.spotifyTrackId || release?.spotifyTrackId,
    });
    setPlayToken((t) => t + 1);
  }, []);

  return (
    <PlayerContext.Provider
      value={{ currentRelease, currentTrack, playToken, isPlaying, setIsPlaying, playRelease }}
    >
      {children}
    </PlayerContext.Provider>
  );
}

export function usePlayer() {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error("usePlayer must be used within PlayerProvider");
  return ctx;
}
